import React from 'react';
import { ScreenContainer, SimpleFullContainer } from 'styles/ContainerStyles';
import { isWeb } from 'utils/deviceUtils';
import SalesOrderPermitDetails from '../permit/salesOrder/SalesOrderPermitDetails';

const Container: any = isWeb ? ScreenContainer : SimpleFullContainer;

const PermitHistoryDetailsScreen: React.FC = () => (
  <Container mt={200}>
    <SalesOrderPermitDetails isHistory={true} />
  </Container>
);

export default PermitHistoryDetailsScreen;
